/**
 * ReadingStep
 * Sonuç sayfasında tek bir bölüm
 */

import React from 'react';

export default function ReadingStep({ section, isActive }) {
  if (!section) return null;
  
  return (
    <div 
      className="oracle-step-container"
      style={{ display: isActive ? 'block' : 'none' }}
    >
      <div className="oracle-step-header">
        <div className="oracle-step-icon">{section.icon || '✨'}</div>
        <h2 className="oracle-step-title">{section.title}</h2>
      </div>
      
      <div className="oracle-step-content">
        {section.content?.split('\n').map((paragraph, i) => (
          <p key={i} style={{ marginBottom: 16 }}>{paragraph}</p>
        ))}
      </div>
      
      {section.tags && section.tags.length > 0 && (
        <div className="oracle-step-tags">
          {section.tags.map((tag, i) => (
            <span key={i} className="oracle-step-tag">{tag}</span>
          ))}
        </div>
      )}
    </div>
  );
}
